export default "assets/images/marker-a4c4f6f9.png";